<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="todo__filters-container">

        <!-- all 
        <div class="px-6 py-4">
            <router-link tag="span" class="flex cursor-pointer" :class="{'text-primary': todoFilter == 'all'}" :to="`${baseUrl}/all`">
                <feather-icon icon="LayersIcon" :svgClasses="[{'text-primary stroke-current': todoFilter == 'all'}, 'h-6 w-6']"></feather-icon>
                <span class="text-lg ml-3">All</span>
            </router-link>
        </div>-->
        <!-- classe-->
        <div class="px-6 py-4">
          <span class="text-lg ml-3 mb-5">Formation</span>
          <v-select :options="classe_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="classe_data" class="mb-4 md:mb-0 mt-2" />
        </div>
        <vs-divider></vs-divider>
        
        <!-- starred -->
        <div class="px-6 py-4">
            <h5>Groupe</h5>
            <template v-for="filter in $store.state.formation.groupes">
                <router-link tag="span" class="flex mt-6 cursor-pointer" :class="{'text-primary': todoFilter == filter.id}" :to="`${baseUrl}/${filter.id}/${filter.formation_id}`" :key="filter.id">
                    <feather-icon icon='ListIcon' :svgClasses="[{'text-primary stroke-current': todoFilter == filter.id}, 'h-6 w-6']"></feather-icon>
                    <span class="text-lg ml-3">Groupe {{ filter.numero }}</span>
                </router-link>
            </template>

        </div>

        <vs-divider></vs-divider>
        
        

    </div>
</template>
<script>
import moduleformation from '@/store/formation/moduleformation.js'
import vSelect from 'vue-select'

export default {
  data() {
        return {
            todoFilters: [
                
            ],
            //classe_data:{label:obj.label, value: obj.value}
        }
    },
    components: {
    vSelect
  },
  computed: {
    
        classe_choices() {
          
        //this.$store.dispatch("classe/fetchSeances",this.$route.params.filter).catch(err => { console.error(err) })     
  
        let opts=[];
          for (var classe of this.$store.state.formation.users) {
              opts.push({label:classe.titre, value: classe.id});
              
            }
            console.log('classe_choices',opts)
         return opts
    },
    classe_data: {
      get() {
        
        
        },
      set(obj) {
        
        this.$store.dispatch("formation/fetchGroupes",obj.value).catch(err => { console.error(err) })
        //return {label:obj.label, value: obj.value}
        //console.log(obj.value)
      }
    },
        todoFilter() {
            return this.$route.params.filter
        },
        baseUrl() {
          //console.log('seance',this.$route.params.groupe)
          //console.log('this.$route.path0',this.$route.path)
          const path = this.$route.path
         // console.log('this.$route.path1',path.slice(0, path.lastIndexOf("/")))
          const pathh = path.slice(0, path.lastIndexOf("/"))
          //console.log('this.$route.path2',pathh.slice(0, path.lastIndexOf("/")))
          return path.slice(0, pathh.lastIndexOf("/")).slice(0, path.lastIndexOf("/"))
        },
        
    },
  methods: {
    
    },
  created() {
    // Register Module UserManagement Module
    if(!moduleformation.isRegistered) {
      this.$store.registerModule('formation', moduleformation)
      moduleformation.isRegistered = true
    }
    
    //this.$store.dispatch("classe/fetchSeances",1).catch(err => { console.error(err) })
    this.$store.dispatch("formation/fetchUsers").catch(err => { console.error(err) })
    this.$store.dispatch("formation/fetchGroupes",this.$route.params.groupe).catch(err => { console.error(err) })
     let filter = this.$route.params.filter
     //console.log('370',filter) 
    },
}

</script>
